<template>
    <section class="container" aria-label="Site hours">
        <div class="site-detail-hours">
            <!-- <div class="status flex-row">
        <SvgsClock />
        <p class="headline-4">Hours: {{ hoursStatus }}</p>
      </div> -->
            <div class="regular-hours flex-row">
                <div v-if="site.fields['Saturday Hours']">
                    <p class="small-heavy">Saturday</p>
                    <p class="small-book">
                        {{ processTime(site.fields['Saturday Hours']) }}
                    </p>
                </div>
                <div v-if="!site.fields['Saturday Hours']">
                    <p class="small-heavy">Saturday</p>
                    <p class="small-book">
                        Closed
                    </p>
                </div>                
                <div v-if="site.fields['Sunday Hours']">
                    <p class="small-heavy">Sunday</p>
                    <p class="small-book">
                        {{ processTime(site.fields['Sunday Hours']) }}
                    </p>
                </div>  
                <div v-if="!site.fields['Sunday Hours']">
                    <p class="small-heavy">Sunday</p>
                    <p class="small-book">
                        CLOSED
                    </p>
                </div>                           
            </div>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        site: {
            type: Object,
            required: true,
        },
    });

    const { site } = toRefs(props);

    const days = {
        6: 'Saturday Hours',
        0: 'Sunday Hours',
    };

    const currentDay = computed(() => {
        const chicagoDateTime = new Date().toLocaleString('en-US', {
            timeZone: 'America/Chicago',
        });
        const formattedDateTime = new Date(chicagoDateTime);
        const currentTime = `${(formattedDateTime.getHours() < 10 ? '0' : '') + formattedDateTime.getHours()}${
            (formattedDateTime.getMinutes() < 10 ? '0' : '') + formattedDateTime.getMinutes()
        }`;
        const day = formattedDateTime.getDay();
        return day;
    });

    const hoursStatus = computed(() => {
        const chicagoDateTime = new Date().toLocaleString('en-US', {
            timeZone: 'America/Chicago',
        });
        const formattedDateTime = new Date(chicagoDateTime);
        const currentTime = `${(formattedDateTime.getHours() < 10 ? '0' : '') + formattedDateTime.getHours()}${
            (formattedDateTime.getMinutes() < 10 ? '0' : '') + formattedDateTime.getMinutes()
        }`;

        let isOpen;

        let dayKey = days[currentDay.value];

        let siteHours = site?.value?.fields[dayKey];

        if (!siteHours) {
            isOpen = false;
        } else if (siteHours && siteHours.toLowerCase() === 'closed') {
            isOpen = false;
        } else {
            const timeStr = siteHours;
            const timeSplit = timeStr.split('-');
            let open = trimTime(timeSplit[0]);
            let close = trimTime(timeSplit[1]);

            if (open <= currentTime && close > currentTime) {
                isOpen = true;
            } else {
                isOpen = false;
            }
        }

        return isOpen ? 'Open Now!' : 'Closed';
    });

    function trimTime(str) {
        let time = str.replace('am', '').replace('pm', '');
        if (!time.includes(':')) {
            time = time + ':00';
        }

        if (time.length < 5) {
            time = '0' + time;
        }

        let hours = time.split(':')[0];
        let mins = time.split(':')[1];

        if (hours.includes('12') && str.includes('am')) {
            hours = '00';
        }

        if (str.includes('pm')) {
            if (hours.startsWith('0')) {
                hours = (parseInt(hours) + 12).toString();
                if (hours.length < 2) {
                    hours = '0' + hours;
                }
            }
        }

        time = `${hours}${mins}`;
        return time;
    }

    function processTime(val) {
        // A range takes an en dash with no spaces: "10am–5pm", and
        // "10am–12:30pm; 4–5pm" for the split days.
        if (val) {
            return val.trim().replace(/\s*-\s*/g, '\u2013');
        }
        return false;
    }
</script>

<style lang="scss">
    .site-detail-hours {
        background: $gray-light;
        margin: 36px 0 0;

        @media (min-width: $tablet) {
            max-width: 500px;
        }
        .status {
            padding: 18px 14px;
            border-bottom: 1px solid black;
        }
        .headline-4 {
            display: block;
            margin-left: 10px;
            margin-top: 3px;
        }
        .regular-hours {
            > div {
                width: 50%;
                padding: 20px;
                &:last-child {
                    border-left: 1px solid $black;
                }
            }
        }
        a {
            text-decoration: underline;
            display: inline-block;
            margin-top: 8px;
        }

        .flex-row {
            display: flex;
            align-items: center;
        }

        .small-heavy {
            text-transform: uppercase;
        }
        .body-book.heavy,
        .small-book.heavy {
            font-weight: 800;
        }
    }
</style>
